(function () {
  'use strict';

  let angular = window.angular;

  Controller.$inject = ['$scope', '$timeout', 'Customer', 'AppUtils'];

  angular.module('app').component('connectionEmergencyContactForm', {
    template:'<form class="validate" name="ctrl.emergencyContactForm" novalidate ng-class="{transparent: ctrl.saving}"><div class="modal-header"><span>{{:: ctrl.emergencyContact.id? \'form.actions.update\': \'form.actions.create\' | translate}}</span> <span translate>entities.emergencycontact.modelName</span></div><div class="modal-body"><div><div class="form-group" show-errors><label for="createEmergencyContactName"><span translate>entities._all.name</span> <span class="text-danger">*</span></label> <input id="createEmergencyContactName" ng-model="ctrl.emergencyContact.name" class="form-control" translate-attr="{placeholder:\'entities._all.name\'}" name="emergencyContactName" required><div class="help-block" ng-messages="ctrl.emergencyContactForm.emergencyContactName.$error"><div ng-messages-include="messages.html"></div></div></div><div class="form-group" show-errors><label for="createEmergencyContactPhone"><span translate>entities.emergencycontact.phone</span> <span class="text-danger">*</span></label><div class="intl-tel-input-block"><input id="createEmergencyContactPhone" ng-model="ctrl.emergencyContact.phone" class="form-control" ng-intl-tel-input initial-country="CL" translate-attr="{placeholder: \'entities.emergencycontact.phone\'}" name="emergencyContactPhone"></div><div class="help-block" ng-messages="ctrl.emergencyContactForm.emergencyContactPhone.$error"><div ng-messages-include="messages.html"></div></div></div><div class="checkbox"><label><input type="checkbox" ng-model="ctrl.emergencyContact.enabled"> <span translate>entities._all.enabled</span></label></div><div class="form-group no-margin"><label class="control-label" for="descriptionInput" translate>entities._all.description</label> <textarea id="descriptionInput" name="descriptionInput" maxlength="10000" simplemde="ctrl.mdeOptions" ng-model="ctrl.emergencyContact.description" class="form-control input-sm"></textarea></div></div></div><div ng-if="ctrl.createEmergencyContactError" class="alert alert-warning text-center marginB0">{{ctrl.createEmergencyContactError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" ng-show="!ctrl.saving" translate>buttons.cancel</button> <button ng-disabled="ctrl.saving" class="btn btn-primary" ng-click="ctrl.save()" translate>buttons.save</button></div></form><spinner css-class="\'small\'" show-logo="true" show="ctrl.saving"></spinner>',
    controller: Controller,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function Controller($scope, $timeout, Customer, utils) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.emergencyContact = vm.resolve.emergencyContact
        ? angular.copy(vm.resolve.emergencyContact)
        : {};
      vm.operation = vm.emergencyContact.id ? 'Update' : 'Create';
      vm.customer = vm.resolve.customer;

      vm.mdeOptions = {
        spellChecker: false,
        toolbar: [
          'bold',
          'italic',
          'heading',
          '|',
          'unordered-list',
          'ordered-list',
          '|',
          'quote',
          'link',
          'table',
          'code',
          '|',
          'preview',
        ],
      };

      vm.save = createEmergencyContact;
    };

    function createEmergencyContact() {
      $scope.$broadcast('show-errors-check-validity');
      if (!vm.emergencyContact || !vm.emergencyContactForm.$valid) {
        return;
      }

      let emergencyContact = {
        name: vm.emergencyContact.name,
        phone: vm.emergencyContact.phone,
        description: vm.emergencyContact.description,
        enabled: vm.emergencyContact.enabled,
      };

      let promise;
      if (vm.emergencyContact.id) {
        promise = Customer.emergencyContacts.updateById(
          {
            id: vm.customer.id,
            fk: vm.emergencyContact.id,
          },
          emergencyContact
        ).$promise;
      } else {
        promise = Customer.emergencyContacts.create(
          {
            id: vm.customer.id,
          },
          emergencyContact
        ).$promise;
      }

      vm.saving = true;
      promise
        .then(function (result) {
          vm.modalInstance.close({
            operation: vm.emergencyContact.id ? 'update' : 'create',
            emergencyContact: result,
            node: {
              id: result.id,
              text: result.name,
              parent: '#',
            },
          });
        })
        .catch(function (err) {
          vm.saving = false;
          vm.createEmergencyContactError = utils.getHTTPError(err);
        });
    }
  }
})();
